import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

// Bearer token fallback (for admin panel where cookies may not stick cross-origin)
const TOKEN_KEY = "cuquito_token";
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  return config;
});

export const mediaUrl = (urlOrId) => {
  if (!urlOrId) return "";
  if (urlOrId.startsWith("http") || urlOrId.startsWith("data:")) return urlOrId;
  if (urlOrId.startsWith("/api/")) return `${BACKEND_URL}${urlOrId}`;
  return urlOrId;
};
